import { Controller } from '@hotwired/stimulus';

// Envoi d'un e-mail ou d'une notification : nombre de destinataires demandé
// au serveur à chaque changement des destinataires (`url`, POST des champs
// de destinataires avec le jeton CSRF de la page, réponse { count } ; une
// longue liste d'adresses ne tient pas dans une adresse), affiché et repris dans la confirmation ; zéro :
// envoi bloqué.
// Seule la dernière réponse compte ; un envoi pendant le calcul attend le
// nombre à jour avant de demander confirmation.
const TEXT_FIELDS = /\[(subject|body|title|content|category)\]$|^documents\[\]$|^authenticity_token$|^_method$/;

export default class extends Controller {
    static targets = ['output'];
    static values = { url: String, noun: String };

    connect() {
        this.refresh();
    }

    refresh(event) {
        if (event && TEXT_FIELDS.test(event.target.name || '')) return;
        clearTimeout(this.timer);
        this.pending = new Promise((resolve) => {
            this.timer = setTimeout(() => this.load().then(resolve), 250);
        });
    }

    async load() {
        const body = new FormData();
        new FormData(this.element).forEach((value, name) => {
            if (!TEXT_FIELDS.test(name)) body.append(name, value);
        });
        const request = Symbol('count');
        this.request = request;
        let count = null;
        try {
            const token = document.querySelector('meta[name="csrf-token"]')?.content;
            const response = await fetch(this.urlValue, { method: 'POST', body, headers: { Accept: 'application/json', 'X-CSRF-Token': token } });
            if (response.ok) ({ count } = await response.json());
        } catch (error) {
            count = null;
        }
        if (this.request !== request) return;
        this.count = Number.isInteger(count) ? count : null;
        this.pending = null;
        this.show();
    }

    show() {
        if (this.count === null) {
            this.outputTarget.textContent = 'Nombre de destinataires indisponible.';
        } else {
            this.outputTarget.textContent = this.count ? `${this.count} destinataire${this.count > 1 ? 's' : ''}` : 'Aucun destinataire';
        }
        this.outputTarget.classList.toggle('text-ko', this.count === 0);
    }

    async confirm(event) {
        if (event.defaultPrevented) return;
        if (this.pending) {
            event.preventDefault();
            this.outputTarget.textContent = 'Calcul du nombre de destinataires…';
            const { submitter } = event;
            await this.pending;
            this.element.requestSubmit(submitter);
            return;
        }
        if (this.count === 0) {
            event.preventDefault();
            this.outputTarget.textContent = 'Aucun destinataire : choisissez qui reçoit le message.';
            return;
        }
        const total = this.count ? ` à ${this.count} destinataire${this.count > 1 ? 's' : ''}` : '';
        this.element.dataset.turboConfirm = `Envoyer ${this.nounValue}${total} ?`;
    }
}
